import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import { VButton } from '../common/components';
import CalendarIcon from 'ah-common-lib/src/icons/components/CalendarIcon.vue';
import ArrowLeftIcon from 'ah-common-lib/src/icons/components/ArrowLeftIcon.vue';
import ArrowRightIcon from 'ah-common-lib/src/icons/components/ArrowRightIcon.vue';
import ChevronDownIcon from 'ah-common-lib/src/icons/components/ChevronDownIcon.vue';

/**
 * Month selector component
 *
 * Month selector component, managing UI state accross a flow of user inputs to select year and month
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'MonthSelector',
  props: {
  value: {
    type: Date,
  },
  min: {
    type: Date,
  },
  max: {
    type: Date,
  },
},
  emits: {
  cancel: () => true,
  'update:value': (_value: Date) => true,
},
  setup(__props, { emit }) {

const props = __props;





const selectionHolder = ref<HTMLDivElement>();

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const yearVal = ref(new Date().getFullYear());
const monthVal = ref(new Date().getMonth());
const uiState = ref<'month-select' | 'year-select'>('month-select');

const yearOptions = computed(() => {
  const minYear = props.min ? props.min.getFullYear() : 1970;
  const maxYear = props.max ? props.max.getFullYear() : new Date().getFullYear();

  const out: number[] = [];

  for (let i = minYear; i <= maxYear; i++) {
    out.push(i);
  }
  return out;
});

function submitValue() {
  emit('update:value', new Date(yearVal.value, monthVal.value, 1));
}

function cancelValue() {
  emit('cancel');
}

function isSetValid(year: number, month: number) {
  const date = new Date(year, month, 1);

  if (props.max && props.max < date) {
    return false;
  }

  if (props.min && props.min > date) {
    return false;
  }

  return true;
}

function selectYear(year: number) {
  setYear(year);
  toggleYearSelection(false);
}

function setYear(year: number) {
  if (isSetValid(year, monthVal.value)) {
    yearVal.value = year;
    scrollToYear();
  }
}

function setMonth(month: number) {
  if (isSetValid(yearVal.value, month)) {
    monthVal.value = month;
  }
}

function toggleYearSelection(on: boolean) {
  uiState.value = on ? 'year-select' : 'month-select';
  if (on) {
    scrollToYear();
  }
}

function scrollToYear() {
  if (uiState.value === 'year-select') {
    setTimeout(() => {
      if (selectionHolder.value) {
        const selectedYear = selectionHolder.value.getElementsByClassName('selected').item(0);
        if (selectedYear) {
          selectionHolder.value.scrollTop = (selectedYear as HTMLDivElement).offsetTop;
        }
      }
    });
  }
}

watch(
  () => props.value,
  () => {
    if (props.value) {
      yearVal.value = props.value.getFullYear();
      monthVal.value = props.value.getMonth();
    }
  },
  {
    immediate: true,
  }
);

return { __sfc: true,props, emit, selectionHolder, months, yearVal, monthVal, uiState, yearOptions, submitValue, cancelValue, isSetValid, selectYear, setYear, setMonth, toggleYearSelection, scrollToYear, VButton, CalendarIcon, ArrowLeftIcon, ArrowRightIcon, ChevronDownIcon }
}

})